import { Component, Input, inject } from '@angular/core';
import { NgOptimizedImage } from "@angular/common";
import {FileUploadService} from "../../../services/file-upload.service";

@Component({
  selector: 'app-image',
  imports: [
    NgOptimizedImage
],
  templateUrl: './image.component.html',
  styleUrl: './image.component.css'
})
export class ImageComponent {
  private uploadService = inject(FileUploadService);

  @Input()
  src: string | null = null;
  @Input()
  width: number | null = null;
  @Input()
  height: number | null = null;

  getPresignedUrl() {
    if (this.src) {
      this.uploadService.getPresignedUrl(this.src).subscribe((res: any) => {
        this.src = res["image_url"];
      })
    }
  }
}
